import CloseIcon from '@rsuite/icons/Close'
import ReloadIcon from '@rsuite/icons/Reload'
import SearchIcon from '@rsuite/icons/Search'
import {isEmpty} from 'lodash'
import {useCallback, useEffect, useState} from 'react'
import {FaPlus, FaSearch} from 'react-icons/fa'
import {BsFiletypeCsv} from 'react-icons/bs'

import {RiDeleteBin6Line} from 'react-icons/ri'
import Select from 'rsuite/SelectPicker'
import Input from 'rsuite/Input'
import {Input as InputAntd} from 'antd'
import InputGroup from 'rsuite/InputGroup'
import {ItemType, StateParamsModel} from '../Model'
import CheckPermissions from '../checkPermission'
import {Col, Row, Select as SelectAntd, Tooltip} from 'antd'

//includes
import {Form, Formik} from 'formik'
import moment from 'moment'
import {useSelector} from 'react-redux'
import {handleLabelNameChanges} from 'src/cms/helpers/automation'
import DatePickerForGrievance from 'src/cms/helpers/components/forms/DatePickerForGrievance'
import {ISettingTypeState} from '../../siteSettings/components/settings'
import SortModal from './sortModal'
import DateFilter from './DateFilter'

interface Props {
  moduleName?: any
  params?: StateParamsModel
  setParams?: any
  filterSelect?: boolean
  filterSelectOptions?: {label: string; value: string | number}[]
  onFilterSelectChange?: (value: string | number) => void
  filterSelectPlaceholder?: string
  filterSelectValue?: string | number

  secondaryFilterSelect?: boolean
  secondaryFilterSelectOptions?: {label: string; value: string | number}[]
  onSecondaryFilterSelectChange?: (value: string | number) => void
  secondaryFilterSelectPlaceholder?: string
  secondaryFilterSelectValue?: string | number

  tertiaryFilterSelect?: boolean
  tertiaryFilterSelectOptions?: {label: string; value: string | number}[]
  onTertiaryFilterSelectChange?: (value: string | number) => void
  tertiaryFilterSelectPlaceholder?: string
  tertiaryFilterSelectValue?: any

  fourthFilterSelect?: boolean
  fourthFilterSelectOptions?: {label: string; value: string | number}[]
  onFourthFilterSelectChange?: (value: string | number) => void
  fourthFilterSelectPlaceholder?: string
  fourthFilterSelectValue?: string | number

  fifthFilterSelect?: boolean
  fifthFilterSelectOptions?: {label: string; value: string | number}[]
  onFifthFilterSelectChange?: (value: string | number) => void
  fifthFilterSelectPlaceholder?: string
  fifthFilterSelectValue?: string | number
  showFilterButton?: boolean
  handleAddModal?: () => void
  handleAddStatus?: () => void
  handleAddNotice?: () => void
  handleAddNotice1?: () => void
  handleAlertOpen?: () => void
  enableMultiple?: () => void
  disableMultiple?: () => void
  handleExport?: () => void
  exportLoading?: boolean
  handleRefresh?: () => void
  handleFilter?: () => void
  handleGetAllData?: () => void
  handleTemplateExport?: () => void
  templateLinkShow?: boolean
  templateButtonName?: string
  handleImport?: any
  handleClickImport?: any
  filterData?: boolean
  filterByBranch?: boolean
  addShow?: boolean
  updateShow?: boolean
  addNoteShow?: boolean
  addNoteMemberTypeShow?: any
  addNoteShow1?: boolean
  deleteShow?: boolean
  exportShow?: boolean
  importShow?: boolean
  importShow1?: boolean
  toggleMultipleShow?: boolean
  disableButton?: boolean
  exportButtonName?: string
  sortShow?: boolean
  sortButtonName?: string
  activeButtonName?: any
  inactiveButtonName?: string
  openSortModal?: boolean
  setOpenSortModal?: any
  data?: Array<{[key: string]: string | number}> | undefined
  handleSubmitSort?: (data: Array<ItemType>) => void
  loading?: boolean
  downloadResumeShow?: boolean
  groupDiscussion?: boolean
  interview?: boolean
  handleDownloadResume?: () => void
  enableDiscussion?: () => void
  enableInterview?: () => void
  showSync?: boolean
  handleShowSync?: () => void
  syncText?: string
  syncLoading?: boolean
  showSubSchemeSync?: boolean
  handleShowSubSchemeSync?: () => void
  subSchemeSyncLoading?: boolean
  showSearchOnTop?: boolean
  setDateValue?: (value: any) => void | undefined
  additionalFilters?: Array<{
    key: string
    placeholder?: string
    value?: string | number | (string | number)[]
    onChange: (value: string | number | (string | number)[] | undefined) => void
    options: {label: string; value: string | number}[]
    mode?: 'multiple' | 'tags'
    showSearch?: boolean
    optionFilterProp?: string
    maxTagCount?: number
    allowClear?: boolean
    style?: {[key: string]: string | number}
  }>
}

const DesignComponent = ({
  moduleName,
  params,
  setParams,
  groupDiscussion = false,
  interview = false,
  handleAddModal,
  handleAddStatus,
  handleAddNotice,
  handleAddNotice1,
  handleAlertOpen,
  handleClickImport,
  handleExport,
  exportLoading,
  enableMultiple,
  disableMultiple,
  handleRefresh,
  handleFilter,
  handleGetAllData,
  handleTemplateExport,
  handleImport,
  templateLinkShow = false,
  templateButtonName,
  filterData = false,
  filterByBranch = false,
  showFilterButton = true,
  addShow = true,
  updateShow = false,
  addNoteShow = false,
  addNoteMemberTypeShow = false,
  addNoteShow1 = false,
  deleteShow = true,
  exportShow = true,
  importShow = true,
  importShow1 = false,
  toggleMultipleShow = true,
  exportButtonName,
  sortShow,
  sortButtonName,
  activeButtonName,
  inactiveButtonName,
  disableButton,
  data,
  openSortModal,
  setOpenSortModal,
  handleSubmitSort,
  loading,
  handleDownloadResume,
  downloadResumeShow,
  enableDiscussion,
  enableInterview,
  filterSelect = false,
  filterSelectOptions,
  onFilterSelectChange,
  filterSelectPlaceholder,
  filterSelectValue,
  secondaryFilterSelect = false,
  secondaryFilterSelectOptions,
  onSecondaryFilterSelectChange,
  secondaryFilterSelectPlaceholder,
  secondaryFilterSelectValue,
  tertiaryFilterSelect = false,
  tertiaryFilterSelectOptions,
  onTertiaryFilterSelectChange,
  tertiaryFilterSelectPlaceholder,
  tertiaryFilterSelectValue,
  fourthFilterSelect = false,
  fourthFilterSelectOptions,
  onFourthFilterSelectChange,
  fourthFilterSelectPlaceholder,
  fourthFilterSelectValue,
  fifthFilterSelect = false,
  fifthFilterSelectOptions,
  onFifthFilterSelectChange,
  fifthFilterSelectPlaceholder,
  fifthFilterSelectValue,
  showSync,
  syncText,
  handleShowSync,
  syncLoading,
  showSubSchemeSync,
  handleShowSubSchemeSync,
  subSchemeSyncLoading,
  showSearchOnTop,
  setDateValue,
  additionalFilters = [],
}: Props) => {
  const [sortData, setSortData] = useState<Array<ItemType>>([])
  const [searchQuery, setSearchQuery] = useState('')
  const [branch, setBranch] = useState<string | null>('')
  const [dateValue, setDateValueState] = useState<{
    fromDate: string | null
    toDate: string | null
  }>({
    fromDate: null,
    toDate: null,
  })

  ///just for menu manager
  const setSortInnerData = (data: Array<any>) => {
    if (data.length > 0) {
      const parentIndex = sortData.findIndex((item) => item.keyId === data[0]?.parentId)
      const updatedSortData = [...sortData]
      if (parentIndex >= 0) {
        updatedSortData[parentIndex].children = data
      }
      setSortData(updatedSortData)
    }
  }
  ///just for menu manager
  const setSortInnerMostData = (data: Array<any>) => {
    if (data?.length > 0) {
      const gParentIndex = sortData?.findIndex((item) => item.keyId === data[0]?.topmenuId)

      const parentIndex = sortData[gParentIndex]?.children?.findIndex(
        (item: any) => item.id === data[0]?.parentId
      )

      const updatedSortData = [...sortData]
      if (!isEmpty(updatedSortData?.[gParentIndex]?.children)) {
        if (!isEmpty(updatedSortData?.[gParentIndex]?.children?.[parentIndex]?.children)) {
          updatedSortData[gParentIndex].children[parentIndex].children = [...data]
        }
      }
      setSortData([...updatedSortData])
    }
  }
  const setSortInnerMostChildData = (
    data: Array<any>,
    index1: number,
    index2: number,
    index3: number
  ) => {
    if (data?.length > 0 && index1 >= 0 && index2 >= 0 && index3 >= 0) {
      const updatedSortData = [...sortData]

      if (!isEmpty(updatedSortData?.[index1]?.children)) {
        if (!isEmpty(updatedSortData?.[index1]?.children?.[index2]?.children)) {
          if (!isEmpty(updatedSortData?.[index1]?.children?.[index2]?.children[index3].children)) {
            updatedSortData[index1].children[index2].children[index3].children = [...data]
          }
        }
      }
      setSortData([...updatedSortData])
    }
  }

  useEffect(() => {
    if (!isEmpty(data)) {
      let newSortData: any = data
        ? data?.map((item, i) => {
            return {
              id: i,
              keyId: item?.id,
              name: item?.name,
              title: item?.title,
              parentId: item?.parentId ? item?.parentId : null,
              children: !isEmpty(item?.children) ? item?.children : null,
              menuType: item.menuType,
            }
          })
        : []
      setSortData(newSortData)
    }
  }, [data])

  const handleCloseOpenSortModal = () => {
    setOpenSortModal(false)
  }

  // useEffect(() => {
  //   setParams({ ...params, page: 1, search: searchQuery })
  // }, [searchQuery])

  const handleSearch = useCallback(() => {
    setParams({...params, page: 1, search: searchQuery})
  }, [searchQuery])

  const handleDateChange = (name: string, value: string) => {
    setDateValueState({...dateValue, [name]: value})
    if (setDateValue) {
      setDateValue({...dateValue, [name]: value})
    }
  }

  const settings: ISettingTypeState = useSelector((state: any) => state.settingType)
  const showProductAndInterest =
    settings?.data?.setting?.filter((d) => d.name === 'showPopularityAndInterest')[0]?.value === '1'
      ? true
      : false

  return (
    <>
      {/* title */}
      <div className='row g-0 border-bottom align-items-center mb-3 py-3'>
        <div className='col-lg-6'>
          <div
            className='heading__component__title fw-bolder'
            data-cy={moduleName ? `${handleLabelNameChanges(moduleName)}-title` : ''}
          >
            {moduleName}
          </div>
        </div>
        <div className='col-lg-6'>
          <div className='d-flex justify-content-end'>
            {addShow ? (
              <div className='sub_button' onClick={handleAddModal}>
                <CheckPermissions type='Add'>
                  <button className='dt-btn dt-btn-primary' data-cy='add-button'>
                    <FaPlus className='me-2' />
                    Add
                  </button>
                </CheckPermissions>
              </div>
            ) : null}
            {updateShow ? (
              <div
                className='sub_button'
                data-cy='design-update-status-button'
                onClick={handleAddStatus}
              >
                <CheckPermissions type='Add'>
                  <button className='dt-btn dt-btn-primary' data-cy='update-button'>
                    <FaPlus className='me-2' />
                    Update Status
                  </button>
                </CheckPermissions>
              </div>
            ) : null}
            {deleteShow ? (
              <CheckPermissions type='Delete'>
                <div className='sub_button'>
                  <button
                    className='dt-btn dt-btn-secondary'
                    data-cy='delete-button'
                    onClick={handleAlertOpen}
                  >
                    <RiDeleteBin6Line className='me-2' />
                    Delete
                  </button>
                </div>
              </CheckPermissions>
            ) : null}
            {showSync ? (
              <div className='sub_button' onClick={handleShowSync}>
                <CheckPermissions type='Add'>
                  <button className='dt-btn dt-btn-primary' data-cy='add-button'>
                    <FaSearch className='me-2' />
                    {syncLoading ? 'Syncing...' : syncText ? syncText : 'Sync'}
                  </button>
                </CheckPermissions>
              </div>
            ) : null}
            {showSubSchemeSync ? (
              <div className='sub_button' onClick={handleShowSubSchemeSync}>
                <CheckPermissions type='Add'>
                  <button className='dt-btn dt-btn-primary' data-cy='add-button'>
                    <FaSearch className='me-2' />
                    {subSchemeSyncLoading ? 'Syncing...' : 'Sub Scheme Sync'}
                  </button>
                </CheckPermissions>
              </div>
            ) : null}

            {showSearchOnTop ? (
              <div className='d-flex justify-content-end'>
                <InputGroup inside style={{width: 300}}>
                  <Input
                    placeholder='Search'
                    // hidden={fourthFilterSelect}
                    value={searchQuery}
                    onChange={(value) => setSearchQuery(value)}
                    data-cy='design-search-input'
                    size='md'
                  />
                  <InputGroup.Addon className='btn btn-primary rounded-end ' onClick={handleSearch}>
                    <SearchIcon />
                  </InputGroup.Addon>
                </InputGroup>
              </div>
            ) : null}
          </div>
        </div>
      </div>

      {templateLinkShow ? (
        <div className='d-flex justify-content-end align-items-center mb-5'>
          <div className='sub_button'>
            <button
              className='dt-btn dt-btn-outline-primary dt-btn-sm'
              onClick={handleTemplateExport}
              data-cy={`${handleLabelNameChanges(moduleName)}-export-button`}
            >
              {templateButtonName}
            </button>
          </div>
        </div>
      ) : null}
      {/* filter  */}
      <div className='d-flex align-items-center'>
        <div className='d-flex align-items-center flex-wrap mb-3 gap-2'>
          <div className='d-flex'>
            {filterByBranch && (
              <div className='ms-1' style={{zIndex: 10}}>
                <SelectAntd
                  style={{width: '250px', height: '40px'}}
                  placeholder='Filter by Branch'
                  onChange={(value) => setBranch('')}
                  options={[]}
                />
              </div>
            )}
            <div className='d-flex align-items-center flex-wrap gap-2'>
              {filterSelect && filterSelectOptions && (
                <div className='ms-1' style={{minWidth: 100}}>
                  <SelectAntd
                    style={{width: '250px', height: '40px'}}
                    placeholder={filterSelectPlaceholder || 'Select an option'}
                    value={filterSelectValue || undefined}
                    onChange={onFilterSelectChange}
                    options={filterSelectOptions}
                    allowClear
                  />
                </div>
              )}
              {secondaryFilterSelect && secondaryFilterSelectOptions && (
                <div className='ms-1' style={{minWidth: 100}}>
                  <SelectAntd
                    style={{width: '250px', height: '40px'}}
                    placeholder={secondaryFilterSelectPlaceholder || 'Select an option'}
                    value={secondaryFilterSelectValue || undefined}
                    onChange={onSecondaryFilterSelectChange}
                    options={secondaryFilterSelectOptions}
                    allowClear
                  />
                </div>
              )}

              {tertiaryFilterSelect && tertiaryFilterSelectOptions && (
                <div className='ms-1' style={{minWidth: 100}}>
                  <Tooltip
                    placement='topLeft'
                    overlayInnerStyle={{
                      maxWidth: 'none',
                      padding: '10px',
                      minWidth: '380px', // Slightly wider tooltip
                    }}
                    title={
                      <div
                        style={{
                          display: 'grid',
                          gridTemplateColumns: '1fr 1fr', // Two flexible columns
                          gap: '8px 16px',
                          maxHeight: '300px',
                          overflowY: 'auto',
                        }}
                      >
                        {(tertiaryFilterSelectValue || []).map((val: any) => {
                          const label =
                            tertiaryFilterSelectOptions.find((opt) => opt.value === val)?.label ||
                            val
                          return <div key={val}>{label}</div>
                        })}
                      </div>
                    }
                  >
                    <SelectAntd
                      mode='multiple'
                      showSearch
                      optionFilterProp='label'
                      maxTagCount={0}
                      style={{width: '250px', height: '40px'}} // Slightly wider Select
                      placeholder={tertiaryFilterSelectPlaceholder || 'Select an option'}
                      value={tertiaryFilterSelectValue || undefined}
                      onChange={onTertiaryFilterSelectChange}
                      options={tertiaryFilterSelectOptions}
                      allowClear
                    />
                  </Tooltip>
                </div>
              )}

              {fourthFilterSelect && fourthFilterSelectOptions && (
                <div className='ms-1' style={{minWidth: 100}}>
                  <SelectAntd
                    style={{width: '250px', height: '40px'}}
                    placeholder={fourthFilterSelectPlaceholder || 'Select an option'}
                    value={fourthFilterSelectValue || undefined}
                    onChange={onFourthFilterSelectChange}
                    options={fourthFilterSelectOptions}
                    allowClear
                  />
                </div>
              )}

              {fifthFilterSelect && fifthFilterSelectOptions && (
                <div className='ms-1' style={{minWidth: 100}}>
                  <SelectAntd
                    style={{width: '250px', height: '40px'}}
                    placeholder={fifthFilterSelectPlaceholder || 'Select an option'}
                    value={fifthFilterSelectValue || undefined}
                    onChange={onFifthFilterSelectChange}
                    options={fifthFilterSelectOptions}
                    allowClear
                  />
                </div>
              )}

              {additionalFilters &&
                additionalFilters.length > 0 &&
                additionalFilters.map((filter) => (
                  <div key={filter.key} className='ms-1' style={{minWidth: 100}}>
                    {filter.mode === 'multiple' ? (
                      <Tooltip
                        placement='topLeft'
                        overlayInnerStyle={{
                          maxWidth: 'none',
                          padding: '10px',
                          minWidth: '380px',
                        }}
                        title={
                          <div
                            style={{
                              display: 'grid',
                              gridTemplateColumns: '1fr 1fr',
                              gap: '8px 16px',
                              maxHeight: '300px',
                              overflowY: 'auto',
                            }}
                          >
                            {Array.isArray(filter.value) && filter.value.length > 0
                              ? (filter.value as (string | number)[]).map((val: any) => {
                                  const label =
                                    filter.options.find((opt) => opt.value === val)?.label || val
                                  return <div key={val}>{label}</div>
                                })
                              : null}
                          </div>
                        }
                      >
                        <SelectAntd
                          mode={filter.mode}
                          showSearch={filter.showSearch}
                          optionFilterProp={filter.optionFilterProp || 'label'}
                          maxTagCount={filter.maxTagCount || 0}
                          style={filter.style || {width: '250px', height: '40px'}}
                          placeholder={filter.placeholder || 'Select an option'}
                          value={filter.value || undefined}
                          onChange={filter.onChange}
                          options={filter.options}
                          allowClear={filter.allowClear !== false}
                        />
                      </Tooltip>
                    ) : (
                      <SelectAntd
                        showSearch={filter.showSearch}
                        optionFilterProp={filter.optionFilterProp || 'label'}
                        style={filter.style || {width: '250px', height: '40px'}}
                        placeholder={filter.placeholder || 'Select an option'}
                        value={filter.value || undefined}
                        onChange={filter.onChange}
                        options={filter.options}
                        allowClear={filter.allowClear !== false}
                      />
                    )}
                  </div>
                ))}

              {filterData ? (
                <>
                  <Formik
                    initialValues={{
                      fromDate: '',
                      toDate: '',
                    }}
                    onSubmit={(values) => {
                      const fromDate = values.fromDate
                        ? moment(values.fromDate).startOf('day').format('YYYY-MM-DD')
                        : ''
                      const toDate = values.toDate
                        ? moment(values.toDate).endOf('day').format('YYYY-MM-DD')
                        : ''

                      setParams((prev: any) => ({
                        ...prev,
                        from_date: fromDate,
                        to_date: toDate,
                      }))
                      handleGetAllData?.()
                    }}
                  >
                    {({touched, handleChange, errors, values, setFieldValue}) => (
                      // {({ touched, handleChange, errors, values, setFieldValue }) => (
                      <Form>
                        <Row gutter={[16, 16]}>
                          <Col style={{zIndex: 11}} sm={12} md={12} lg={12}>
                            <DatePickerForGrievance
                              containerClassName='col-12'
                              name='fromDate'
                              placeholderText='From date'
                              setFieldValue={(field: any, value: any) => {
                                setFieldValue(field, value)
                                handleDateChange(field, value)
                              }}
                              value={values.fromDate || false}
                              touched={touched}
                              isClearable={true}
                              required={true}
                              showIcon={true}
                              errors={errors}
                            />
                          </Col>
                          <Col style={{zIndex: 11}} sm={12} md={12} lg={12}>
                            <DatePickerForGrievance
                              containerClassName='col-12'
                              name='toDate'
                              placeholderText='To date'
                              setFieldValue={(field: any, value: any) => {
                                setFieldValue(field, value)
                                handleDateChange(field, value)
                              }}
                              value={values.toDate || false}
                              touched={touched}
                              required={true}
                              showIcon={true}
                              errors={errors}
                            />
                          </Col>
                        </Row>
                      </Form>
                    )}
                  </Formik>
                  {/* <DateFilter params={params} setParams={setParams} onDateChange={setDateValue} /> */}
                </>
              ) : null}
              <div className='d-flex'>
                {showFilterButton && (
                  <div className='sub_button  py-2'>
                    <button className='dt-btn dt-btn-primary' onClick={handleFilter}>
                      Apply Filter
                    </button>
                  </div>
                )}

                <div className='sub_button pt-3 pl-2'>
                  <button
                    className='dt-btn dt-btn-outline-primary dt-btn-sm'
                    onClick={handleRefresh}
                    data-cy='refresh-button'
                  >
                    <ReloadIcon />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {!showSearchOnTop && (
        <div className='d-flex justify-content-end'>
          <InputGroup inside style={{width: 300}}>
            <Input
              placeholder='Search'
              // hidden={fourthFilterSelect}
              value={searchQuery}
              onChange={(value) => setSearchQuery(value)}
              data-cy='design-search-input'
              size='md'
            />
            <InputGroup.Addon className='btn btn-primary rounded-end ' onClick={handleSearch}>
              <SearchIcon />
            </InputGroup.Addon>
          </InputGroup>
        </div>
      )}
      <div className='d-flex mb-5 justify-content-end'>
        {exportShow ? (
          <div className='me-2'>
            <button
              className='dt-btn dt-btn-primary w-100'
              onClick={handleExport}
              data-cy='export-button'
              style={{height: '40px'}}
              disabled={exportLoading}
            >
              {exportLoading ? 'Exporting...' : exportButtonName || 'Export to CSV'}
            </button>
          </div>
        ) : null}
      </div>

      <SortModal
        isOpen={openSortModal}
        handleClose={handleCloseOpenSortModal}
        data={sortData}
        setSortData={setSortData}
        sortButtonName={sortButtonName}
        handleSubmitSort={handleSubmitSort}
        loading={loading}
        setSortInnerData={setSortInnerData}
        setSortInnerMostData={setSortInnerMostData}
        setSortInnerMostChildData={setSortInnerMostChildData}
      />
    </>
  )
}

export default DesignComponent
